import WebGalleryAdWidgetDiscoveryModalContainer from './WebGalleryAdWidgetDiscoveryModalContainer';

export default WebGalleryAdWidgetDiscoveryModalContainer;
